const SET_TIER = 'scratch-gui/tier/SET_TIER';
const SET_USAGE = 'scratch-gui/tier/SET_USAGE';

const initialState = {
    tier: 'free', // 'free' or 'pro'
    downloadLimit: 5,
    downloadCount: 0,
    uploadLimit: 15,
    uploadCount: 0,
    aiUsageLimit: 10,
    aiUsageCount: 0
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_TIER:
        return Object.assign({}, state, {
            tier: action.tier
        });
    case SET_USAGE:
        return Object.assign({}, state, {
            tier: typeof action.tier !== 'undefined' ? action.tier : state.tier,
            downloadCount: typeof action.downloadCount !== 'undefined' ? action.downloadCount : state.downloadCount,
            uploadCount: typeof action.uploadCount !== 'undefined' ? action.uploadCount : state.uploadCount,
            aiUsageCount: typeof action.aiUsageCount !== 'undefined' ? action.aiUsageCount : state.aiUsageCount,
            downloadLimit: typeof action.downloadLimit !== 'undefined' ? action.downloadLimit : state.downloadLimit,
            uploadLimit: typeof action.uploadLimit !== 'undefined' ? action.uploadLimit : state.uploadLimit,
            aiUsageLimit: typeof action.aiUsageLimit !== 'undefined' ? action.aiUsageLimit : state.aiUsageLimit
        });
    default:
        return state;
    }
};

const setTier = function (tier) {
    return {
        type: SET_TIER,
        tier: tier
    };
};

const setUsage = function (usage) {
    return {
        type: SET_USAGE,
        ...usage
    };
};

export {
    reducer as default,
    initialState as tierInitialState,
    setTier,
    setUsage
};

